import { literalValues } from "@shared/validation/literal-values";

export const BANK_CLEARING_STATUS = {
  CLEARING: "clearing",
  FAILED: "failed",
  SETTLED: "settled",
} as const;

export const BANK_CLEARING_STATUSES = literalValues(BANK_CLEARING_STATUS);

export const ACH_CLEARING_BUSINESS_DAYS = 4;

export const ACH_PAYMENT_METHOD_TYPE = "us_bank_account";

export const ACH_PROCESSING_INTENT_STATUS = "processing";

export const ACH_FAILURE_REASON_LABEL: Readonly<Record<string, string>> = {
  insufficient_funds: "Insufficient funds",
  account_closed: "Account closed",
  no_account: "Account not found",
  invalid_account_number: "Invalid account number",
  debit_not_authorized: "Debit not authorized",
  bank_account_restricted: "Account restricted",
  account_frozen: "Account frozen",
};

export const ACH_FAILURE_FALLBACK_REASON = "The bank returned the payment";
